import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './FormFieldText.css';

/**
 * FormFieldText Component
 */
export default class FormFieldText extends Component {

    /**
     * Default props.
     *
     * @type {{errorText: string, maxLength: number, type: string}}
     */
    static defaultProps = {
        errorText: "Error",
        maxLength: 200,
        type: 'text'
    };

    /**
     * Prop Types
     *
     * @type {{id: *, errorText: shim, inputChange: shim, labelText: *, maxLength: shim, type: shim, valid: *, validateFunction: *}}
     */
    static propTypes = {
        id: PropTypes.string.isRequired,
        errorText: PropTypes.string,
        inputChange: PropTypes.func,
        labelText: PropTypes.string,
        maxLength: PropTypes.number,
        type: PropTypes.string,
        valid: PropTypes.bool,
        validateFunction: PropTypes.func.isRequired
    };

    /**
     * State
     *
     * @type {{errorClassName: string, inputClassName: string, inputText: string}}
     */
    state = {
        errorClassName: "FormFieldText-error-hidden",
        inputClassName: "FormFieldText-valid",
        inputText: ""
    };

    /**
     * Constructor
     *
     * @param props
     */
    constructor(props) {
        super(props);

        this.inputChange = this.inputChange.bind(this);
    }

    /**
     * Component will receive props
     *
     * @param {object} nextProps
     */
    componentWillReceiveProps(nextProps) {
        let inputClassName = "FormFieldText-valid";
        let errorClassName = "FormFieldText-error-hidden";

        if(nextProps.valid === false) {
            inputClassName = "FormFieldText-invalid";
            errorClassName = "FormFieldText-error-visible"
        }

        this.setState({
            inputClassName: inputClassName,
            errorClassName: errorClassName
        });
    }

    /**
     * Input change
     *
     * @param event
     */
    inputChange(event) {
        const {inputChange} = this.props;

        let inputText = event.target.value;

        this.setState({
            inputText: inputText
        });

        if (inputChange !== undefined) {
            inputChange(event);
        }
    }

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        const {id, errorText, labelText, maxLength, placeholder, type, validateFunction} = this.props;
        const {errorClassName, inputClassName, inputText} = this.state;

        let errorId = id + '-error';

        return (
            <div>
                <label htmlFor={id}>
                    {labelText} <strong><abbr title="required">*</abbr></strong>
                    <input id={id}
                           className={inputClassName}
                           value={inputText}
                           type={type}
                           placeholder={placeholder}
                           required
                           maxLength={maxLength}
                           onChange={this.inputChange}
                           onBlur={validateFunction}/>
                    <div id={errorId}
                         className={errorClassName}>{errorText}</div>
                </label>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/form/formFieldText/FormFieldText.jsx